import React from "react";
import { ColorPicker } from "antd";
import type { Color } from "antd/es/color-picker";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleColorPickerProps extends React.ComponentProps<typeof ColorPicker> {
  useEditorTheme?: boolean;
}

export type { Color as TrebbleColorPickerValue };

const TrebbleColorPicker = ({ useEditorTheme, ...restProps }: TrebbleColorPickerProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <ColorPicker 
        {...restProps} 
      />
    </TrebbleConfigProvider>
  );
};

export default TrebbleColorPicker; 